<template>
    <section>
        <v-container class="fill-height" fluid>
            <v-row justify="center">
                <v-col cols="12" sm="8" md="4">
                    <v-card class="mx-auto">
                        <v-toolbar color="primary" dark flat>
                            <v-toolbar-title class="flex"><img src="@/assets/ares.png" height="50px" width="50px"
                                class="mr-8" />ARES<span class="ml-8">Reset password</span> </v-toolbar-title>
                        </v-toolbar>
                        <v-form ref="form" v-model="valid">
                            <v-card-text v-if="showForm === true">
                                <v-text-field class="pl-8"
                                    name="username"
                                    autocomplete="username"
                                    v-model="gebr.gebr_code"
                                    disabled>
                                </v-text-field>
                                <v-text-field
                                    label="New Password"
                                    v-model="gebr.password"
                                    autocomplete="current-password"
                                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'" :type="show ? 'text' : 'password'"
                                    prepend-icon="mdi-key-variant" :rules="[passwordRules]" @click:append="show = !show"
                                    required>
                                </v-text-field>
                                <div class="bar-container pl-20" v-if="gebr.password!==''">
                                    <!-- Render 5 bars using v-for -->
                                    <div class="mx-2"></div>
                                    <div v-for="index in 5" :key="index">
                                        <div v-if="score >= index" :class="vibe"></div>
                                        <div v-else class="small-bar grey"></div>
                                    </div>
                                </div>
                                <v-text-field label="Re-enter new Password" v-model="gebr.reenteredPassword"
                                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" prepend-icon="mdi-key-variant"
                                    :type="show1 ? 'text' : 'password'" :rules="[passwordRules, passwordConfirmationRule]"
                                    @click:append="show1 = !show1" required>
                                </v-text-field>
                            </v-card-text>
                        </v-form>
                        <v-divider></v-divider>
                        <div class="ml-4"><b>Requirements</b></div>
                        <div class="ml-8">
                           * Have at least one capital letter<br/>
                           * Have at least one lowercase letter<br/>
                           * Have at least one number<br/>
                           * Can't contain a white Space<br/>
                           * Can't contain your own name<br/>
                           * Must be longer than 10 characters<br/>
                           * Can't be a well-known password<br/>
                        </div>
                        <v-divider></v-divider>
                        <v-card-actions v-if="showForm === true">
                            <div class="flex-grow-1"></div>
                            <v-btn type="submit" color="success" :disabled="!valid" @click="doPasswordReset">Change my password</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
            <standard_dialog ref="std_dialog" />
        </v-container>
    </section>
</template>

<script>
    import standard_dialog from '@/components/ui/standard_dialog.vue';
    import { zxcvbn, zxcvbnOptions } from '@zxcvbn-ts/core'
    import * as common from '@zxcvbn-ts/language-common'

    export default {
        components: {
            standard_dialog,
        },
        props: {
            link_encrid: String,
        },
        data() {
            return {
                valid: true,
                loginId: "",
                show: false,
                show1: false,
                snackbar: false,
                showForm: true,
                gebr: {
                    password: "",
                    gebr_naam: ""
                },
                passwordRules: value => {
                    return (
                        this.regex.test(value) ||
                        "Min. 10 characters with at least one capital, one lowercase letter and one number"
                    );
                },
                error_message: "",

                regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{10,}$/

            }
        },
        mounted() {
            zxcvbnOptions.setOptions({
                dictionary: common.dictionary,
                graphs: common.adjacencyGraphs
            })
            this.$axios.post("ares/json/ares/syst/gebr/getGebrToResetPassword.p", {
                header: {
                    request: "getGebrToResetPassword"
                },
                getGebrToResetPassword: {
                    link_encrid: this.link_encrid
                }
            }).then(res => {
                if (res.data.error) {
                    this.$refs.std_dialog.open('error', 'Error', res.data.error.message);
                    this.showForm = false;
                } else {
                    this.gebr = res.data.getGebrToResetPassword;
                    if (res.data.getGebrToResetPassword.color == "error") {
                        this.showForm = false;
                        this.$refs.std_dialog.open('error', 'Error', res.data.getGebrToResetPassword.text);
                    }
                }
            });
        },
        methods: {
            reset() {
                this.$refs.form.reset();
            },
            doLogin(user, password) {
                console.log('u/p', user, password);
                this.$session.start();
                this.$axios.post("ares/json/ares/misc/login.p", {
                    loginId: user,
                    password: password,
                    clientSessionId: this.$session.id()
                }).then(response => {
                    if (response.data.token !== "LoginError") {
                        localStorage.setItem('login', user);
                        this.$session.set("ARES", response.data.token);
                        this.$router.push(response.data.dashboard);
                    } else {
                        this.$refs.std_dialog.open('error', 'Error', 'Login incorrect');
                        this.$session.destroy();
                    }
                })
            },
            doPasswordReset() {
                // this.$session.start();
                this.$axios.post("ares/json/ares/syst/gebr/getGebrToResetPassword.p", {
                    header: {
                        request: "getGebrToResetPassword"
                    },
                    getGebrToResetPassword: {
                        password: this.gebr.password,
                        link_encrid: this.link_encrid
                    }
                }).then(res => {
                    if (res.data.getGebrToResetPassword.color == "success") {
                        this.showForm = false;
                        // this.$session.destroy();
                        this.doLogin(res.data.getGebrToResetPassword.gebr_code, this.gebr.password);
                    } else
                        setTimeout(() => {
                            this.showForm = false;
                            // this.$session.destroy();
                            this.$router.push("/");
                        }, 3000);
                })
            },
        },
        computed: {
            passwordConfirmationRule() {
                return ((this.gebr.password === this.gebr.reenteredPassword)  && (this.score >= 5)) || "Password must match, and meet all criteria below";
            },
            score () {
                if (this.gebr.password === '') return 0

                let sc = zxcvbn(this.gebr.password)
                let newScore = sc.score

                if (newScore === 0) return 1

                // Onze eigen wens: minimaal 20, Hoofdletter, kleine letter, cijfer
                if (!this.regex.test(this.gebr.password)) return newScore

                // " " niet in wachtwoord
                if (this.gebr.password.includes(' ')) return newScore

                let names = this.gebr.gebr_naam.split(" ")

                // voornaam niet in wachtwoord
                if (this.gebr.password.toLowerCase().includes(names[0].toLowerCase())) return newScore

                // achternaam
                if (this.gebr.password.toLowerCase().includes(names[names.length - 1].toLowerCase())) return newScore

                return newScore + 1
            },
            vibe() {
                switch (this.score) {
                    // case 0: return "small-bar error"
                    case 1: return "small-bar error"
                    case 2: return "small-bar orange"
                    case 3: return "small-bar amber"
                    case 4: return "small-bar yellow"
                    case 5: return "small-bar success"
                }
                return "small-bar grey"
            }
        },
    }
</script>

<style scoped>
    .flex {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .bar-container {
        display: flex;
        gap: 8px; /* Space between bars */
        align-items: center;
        padding: 10px;
    }

    .small-bar {
        width: 102px; /* Adjust width as needed */
        height: 6px; /* Adjust height for "small" bar */
        /* background-color: #3498db; *//* Bar color */
        border-radius: 5px; /* Makes the corners rounded */
    }
</style>